module.exports = __webpack_public_path__ + "img/icon-英语@2x.a5a42242.png";